





















































import { computed, defineComponent } from '@nuxtjs/composition-api';
import CollectionPushContent from 'templates/sections/CollectionPush/_internal/CollectionPushContent.vue';

import LoadWhenVisible from '~/components/utils/LoadWhenVisible.vue';
import { useScreenSize } from '~/diptyqueTheme/composable';
import { useFlexibleSection } from '~/diptyqueTheme/composable/useFlexibleSection';
import type { FlexibleSectionModel } from '~/diptyqueTheme/types/contentful';
import { VisualPosition } from '~/diptyqueTheme/types/contentful';

export default defineComponent({
  name: 'DesktopSide',
  components: {
    LoadWhenVisible,
    CollectionPushContent,
    VaimoBanner: () => import('atoms/VaimoBanner.vue'),
    VaimoProducts: () => import('organisms/VaimoProducts.vue')
  },
  props: {
    // TODO: validate sectionData type to ensure it matches FlexibleSectionModel
    sectionData: {
      required: true,
      type: Object
    },
    productsData: {
      required: true,
      type: Object
    }
  },
  setup(props) {
    /**
     * Default aspect ratios for mobile and desktop.
     */
    const DEFAULT_RATIO = {
      mobile: '3:4',
      desktop: '5:6'
    };

    const { isDesktop } = useScreenSize();
    const { visualData, headingData, aspectRatio, hasParallax } =
      useFlexibleSection(
        props.sectionData as FlexibleSectionModel,
        DEFAULT_RATIO
      );

    const parallaxEnabled = computed(
      () => isDesktop.value && hasParallax.value.desktop
    );

    const isReversed = computed(
      () => isDesktop.value && visualData.value.posD === VisualPosition.RIGHT
    );

    const productsLayout = computed(
      () => props.productsData?.layout || 'slider'
    );

    const getWrapperProps = computed(() => {
      const breakpoints = [
        {
          maxWidth: 1530,
          maxItemsVisible: 3
        },
        {
          maxWidth: 1180,
          maxItemsVisible: 2
        },
        {
          maxWidth: 1023,
          maxItemsVisible: 3
        },
        {
          maxWidth: 530,
          maxItemsVisible: 2
        },
        {
          maxWidth: 360,
          maxItemsVisible: 1
        }
      ];

      return {
        slider: {
          desktopShift: 25,
          desktopQuantityVisible: 4,
          variableWidth: true,
          desktopCenterMode: false,
          responsive: breakpoints.map(({ maxWidth, maxItemsVisible }) => ({
            breakpoint: maxWidth,
            settings: {
              slidesToShow: maxItemsVisible,
              slidesToScroll: 2
            }
          }))
        }
      };
    });

    return {
      productsLayout,
      aspectRatio,
      parallaxEnabled,
      isReversed,
      visualData,
      isDesktop,
      getWrapperProps,
      headingData
    };
  }
});
